export enum ChequeStatus {
  PENDING = "cs111111-1111-1111-1111-111111111111",
  CLEARED = "cs222222-2222-2222-2222-222222222222",
  BOUNCED = "cs333333-3333-3333-3333-333333333333",
  CANCELLED = "cs444444-4444-4444-4444-444444444444",
}

export const ChequeStatusInfo = {
  [ChequeStatus.PENDING]: { code: "pending", name: "Pending" },
  [ChequeStatus.CLEARED]: { code: "cleared", name: "Cleared" },
  [ChequeStatus.BOUNCED]: { code: "bounced", name: "Bounced" },
  [ChequeStatus.CANCELLED]: { code: "cancelled", name: "Cancelled" },
} as const;

export const getChequeStatusCode = (value: ChequeStatus): string =>
  ChequeStatusInfo[value].code;
export const getChequeStatusName = (value: ChequeStatus): string =>
  ChequeStatusInfo[value].name;
